module.exports = __webpack_public_path__ + "static/media/wallfinishes_allImpact_60y_n.0507a880.csv";